import { PropsWithChildren } from "react";
import { Infotip } from "../../../shared/Infotip";

const formatNumber = (value: number) =>
  Intl.NumberFormat("en-us").format(value);

interface CardProps {
  title: string;
  tooltipText: string;
}

const Card: React.FC<PropsWithChildren<CardProps>> = ({
  title,
  tooltipText,
  children,
}) => (
  <div className="relative rounded-lg bg-white px-4 py-2">
    <div className="flex items-center justify-between">
      <h3 className="text-sm font-bold">{title}</h3>
      <Infotip
        message={tooltipText}
        options={{
          maxWidth: 200,
          tooltipLeft: true,
        }}
      >
        <i className="far fa-info-circle cursor-pointer text-dm-gray-200" />
      </Infotip>
    </div>
    <div className="py-8 text-center text-2xl text-dm-charcoal-500">
      {children}
    </div>
  </div>
);

export const NumberCard: React.FC<{
  title: string;
  tooltipText: string;
  value: number | undefined;
}> = ({ title, tooltipText, value }) => (
  <Card title={title} tooltipText={tooltipText}>
    {value !== undefined ? formatNumber(value) : "..."}
  </Card>
);

export const PercentageCard: React.FC<{
  title: string;
  tooltipText: string;
  value: number | undefined;
}> = ({ title, tooltipText, value }) => (
  <Card title={title} tooltipText={tooltipText}>
    {value !== undefined ? `${value}%` : "..."}
  </Card>
);
